<template>
    <div class="listmain ">
         <h1 class="firTitle">信息流卡片</h1>
              <p>在有屏设备使用场景中，技能可以通过下发信息流卡片的方式向用户展现更丰富生动的信息。在支付场景中，订单信息将会下发到用户的有屏客户端。
              </p>

              <h5 class="thirdTitle">请求头信息：</h5>
              <p>POST : /intent/invoke HTTP/1.1
                <br>Content-Type :application/x-www-form-urlencoded;charset=UTF-8
                <br>Host : ovs.ainirobot.com
                <br>Content-Length:
                <br>Accept : application/json
                <br>Accept-Charset : utf-8

              </p>
               <h5 class="thirdTitle">请求内容格式规范及参数说明</h5>

              <h5 class="codeTitle">信息流卡片</h5>
              <highlight-code lang="javascript">
              "card": {//Type:JSONObject
            "text":"", //Type:String,输出的文本信息，如果为空该信息不限制
            "ui":[//Type:JSONArray
            {//Type:JSONObject,信息流卡片的展示效果，该字段中的数据根据type类型中的数据进行变化。 如果数据不存在情况下为：null
                "type": "Simple（1）/Image（2）/ImageText（3）/ImageTextButtion（4）/Weather（C1）/WeatherAirQuality（C2）",//Type:String,类型，Simple，Audio ...
                "bg":{//Type:JSONObject,背景的描述
                    "coler":"",//Type:String,背景颜色
                    "image":"",//Type:String,背景图片
                    "virtual":true/false,//Type:Boolean,是否虚化
                },
                "attr":{//Type:JSONObject,属性
                    "title":"",//Type:String,标题
                    "subTitle":"",//Type:String,二级标题
                    "image":"",//Type:String,图片
                    "button":{//Type:JSONObject,按钮
                        "text":"",//Type:String
                        "link":"" //Type:String,button link
                    },
                    "link":"" //Type:String,panle link
                },
                "custom":{}//Type:JSONObject 针对于定制的样式使用该字段，定制的样式现在包括：Weather、WeatherAirQuality
                "skillIcon":{//Type:JSONObject,Skill角标
                    "name":"",//Type:String,角标名称
                    "image":""//Type:String,角标图片
                }
            }
            ],
            "order":{}//支付下单接口,
            "linkAccount":{}//账号关联接口
        }
              </highlight-code>



    </div>
</template>

<script>
export default {
  name: "Ptjj"
};
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 26px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>




// WEBPACK FOOTER //
// src/components/tutor/zdyjn_xxl.vue